import { useQuery } from '@tanstack/react-query';

import { api, getQueryProps, isTruthy } from 'common';

import { FeatureFlagKey, useFlag } from '../../../utils/flags';

export function useApiFindSdkCompletions() {
  const result = useQuery({
    ...getQueryProps(api.client.FlowDefinition, 'findSdkCompletions'),
    staleTime: 5 * 60 * 1000,
  });

  const autoCompleteX12 = useFlag({ flagKey: FeatureFlagKey.autoCompleteX12 });
  if (isTruthy(autoCompleteX12.isEnabled)) {
    return result;
  }
  return {
    ...result,
    data: result.data?.filter((completion) => !completion.label.startsWith('ntbl.x12')),
  };
}
